import { IconButton, InputAdornment } from "@mui/material";
import { TextField } from "./TextField";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React from "react";
import { SxProps } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { FieldPath, FieldValues, RegisterOptions } from "react-hook-form";

interface IProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  fieldName: string;
  fieldLabel?: string;
  sx?: SxProps<Theme>;
  required?: boolean;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
}

export const PasswordInputField = (props: IProps) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const { fieldName, fieldLabel, sx, required, rules } = props;

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      fieldName={fieldName}
      type={showPassword ? "text" : "password"}
      rules={{
        required: "Field Cannot Be Empty",
        minLength: {
          value: 6,
          message: "Password must be at least 6 characters long",
        },
        validate: (value, formValues) => {
          if (/\s/.test(value)) {
            return "Password must not contain spaces";
          }
          // Ensure `rules.validate` is a function before calling it
          if (typeof rules?.validate === "function") {
            const customValidationResult = rules.validate(value, formValues);
            if (customValidationResult !== true) return customValidationResult;
          }

          return true;
        },
      }}
      fieldLabel={fieldLabel}
      endAdornment={
        <InputAdornment position="end">
          <IconButton edge="end" onClick={handleTogglePasswordVisibility}>
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      sx={sx}
      required={required}
      inputProps={{ maxLength: 128 }}
    />
  );
};
